import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { faStar } from '@fortawesome/pro-solid-svg-icons';

import { IcqFeedbackVm } from 'app/shared/generated/ICQ/Models/User/IcqFeedbackVm';
import { SystemMessage, SystemMessageService } from 'app/core/system-message/system-message-service';
import { RecaptchaService } from 'app/services/recaptcha.service';

@Component({
    selector: 'pcg-icq-feedback',
    standalone: false,
    templateUrl: './icq-feedback.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './icq-feedback.component.scss'
})
export class IcqFeedbackComponent {

    formGroup = IcqFeedbackVm.Form;
    starRating: number = 0;
    stars = document.getElementsByClassName("star-icon");
    faIconName = { faStar };
    isError = false;

    isSubmitting = signal<boolean>(false);

    constructor(
        private http: HttpClient
        , private route: ActivatedRoute
        , private sm: SystemMessageService
        , private recaptchaService : RecaptchaService
    ) { }

    ngOnInit() {
        this.getFeedback();
    }

    getFeedback() {
        this.http.get(`api/ICQ/IcqReview/GetIcqFeedback?feedbackId=${this.route.snapshot.params.id}&guid=${this.route.snapshot.params.guid}`)
            .subscribe((msg: SystemMessage) => { this.formGroup.patchValue(msg.model); });
    }

    addStars(starNum) {
        this.removeStars();
        for (let i=0; i < starNum; i++) { this.stars[i]?.classList?.add("star-icon-filled"); }
        this.starRating = starNum;
    }

    removeStars() { for (let i=0; i < 5; i++) { this.stars[i]?.classList?.remove("star-icon-filled"); } }

    saveForm() {
        this.isError = false;
        if (this.starRating > 0) { this.formGroup.controls.rating.setValue(this.starRating); }
        else {
            this.isError = true;
            return;
        }

        // Submit with reCAPTCHA protection
        this.recaptchaService.submit(
            {
                action: 'saveIcqFeedback',
                apiEndpoint: 'api/Icq/IcqReview/SaveFeedback',
                formGroup: this.formGroup,
                loadingSignal: this.isSubmitting
            },
            {
                onSuccess: (msg: SystemMessage) => {
                    if (!msg.isSuccessful) {
                        this.sm.setSystemMessage(msg.message, msg.messageClass);
                        this.formGroup.controls.rating.setValue(0); 
                        this.addStars(0);
                    } 
                }
            }
        );
    }
}
